import axios from "axios";
import { Base_URL } from "../url";

export const saveRegionDetails = async (regionData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/RegionMaster/RegionMaster?UserName=${username}`,
      regionData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving region details!";
  }
};

export const getAllCountries = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CountryMaster/GetAllCountries`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching countries!";
  }
};